import type { CronJobState } from '@/frontend/pages/Dashboard/DigitalWorkers/types'

const LABELS: Record<string, string> = {
  pending: 'Entrega pendente',
  delivered: 'Resultado entregue',
  unknown: 'Entrega não confirmada',
  failed: 'Falha na entrega',
  cancelled: 'Entrega cancelada',
  suppressed: 'Entrega suprimida',
}

export default function RoutineDeliveryStatus({ state }: { state: CronJobState }) {
  const label = state.lastDeliveryStatus && LABELS[state.lastDeliveryStatus]
  if (!label) return null

  return <p className="mt-1 text-xs text-muted-foreground" title={state.lastDeliveryError || undefined}>{label}</p>
}
